const getCompanyTier = (company) =>
  company?.get?.('tier') ?? company?.tier ?? null;

export const isNetXCompany = (company) => {
  const tier = getCompanyTier(company);
  if (typeof tier !== 'string') return false;

  const normalizedTier = tier.trim().toUpperCase();
  return normalizedTier === 'NETX' || normalizedTier === 'ENTERPRISE';
};

export const isOneMonthNetTerm = (term) =>
  term?.get?.('term_period') === 'monthly' && term?.get?.('term') === 1;

export const getNetTermDays = (term) =>
  isOneMonthNetTerm(term) ? 30 : term?.get?.('term');

export const isNetTermsBucketTerm = (term) =>
  term?.get?.('term_period') === 'days' || isOneMonthNetTerm(term);

export const isPayOverTimeBucketTerm = (term) =>
  term?.get?.('term_period') === 'monthly' && !isOneMonthNetTerm(term);

export const isPayNowTerm = (term) => term?.get?.('term_period') === 'now';

export const shouldUseSectionCardLayout = () => {
  return true;
};
